import React from 'react';
import { useHistory } from 'react-router';
import { Icons } from '../../../../assets';
import ContainerModal from '../container-modal';
import { ButtonCustom } from '../../..';

import * as s from './styled-modal-cancelar-criacao-contratante';

const ModalCancelarContractor = ({ isOpen, closeModal }) => {
	const history = useHistory();
	return (
		<ContainerModal isOpen={isOpen} closeModal={closeModal}>
			<s.Content>
				<s.Imagem>
					<Icons.InfoTriangleIcon />
				</s.Imagem>
				<s.Title>CANCELAR CRIAÇÃO DO CONTRATANTE</s.Title>
				<s.Subtitle>
					Tem certeza que deseja cancelar a criação deste contratante? <br />{' '}
					Todas as informações serão perdidas.
				</s.Subtitle>
				<s.ButtonGroup>
					<ButtonCustom width="15rem" textTransform="none" onClick={closeModal}>
						Não, quero manter
					</ButtonCustom>
					<ButtonCustom
						textTransform="none"
						outlined
						width="15rem"
						theme="alert-white"
						onClick={() => history.push('/contratantes')}
						className="button-custom-cancelar"
					>
						Sim, quero cancelar
					</ButtonCustom>
				</s.ButtonGroup>
			</s.Content>
		</ContainerModal>
	);
};

export default ModalCancelarContractor;
